import { EASY, ELITE, OVERWHELMING, STANDARD } from "../../difficulty.config";
import { APPEARANCE } from "../defaults/appearance";

export const arash = {
  [EASY]: {
    STR: 6,
    DEX: 8,
    CON: 8,
    WIL: 6,
    INT: 5,
    CHA: 0,
    attackSkill: 3,
    damage: "(1D8)+5",
    wounds: 1,
    awareness: 5,
    armor: 0,
    defense: 0,
    abilities: [],
    roleProperties: [],
  },
  [STANDARD]: {
    STR: 11,
    DEX: 11,
    CON: 10,
    WIL: 10,
    INT: 8,
    CHA: 0,
    attackSkill: 5,
    damage: "(1D8)+5",
    wounds: 1,
    awareness: 10,
    armor: 1,
    defense: 1,
    abilities: ["Aim"],
    roleProperties: [
      "The Arash skips its turn but adds +10 to its next attack skill.",
    ],
    appearance: APPEARANCE.HUMANOID
  },
  [ELITE]: {
    STR: 12,
    DEX: 15,
    CON: 12,
    WIL: 12,
    INT: 8,
    CHA: 0,
    attackSkill: 8,
    damage: "(2D12)",
    wounds: 2,
    awareness: 15,
    armor: 2,
    defense: 2,
    abilities: ["Aim", "Explosive"],
    roleProperties: [
      "The Arash skips its turn but adds +10 to its next attack skill.",
      "The Arash launches an explosive round that deals D20 damage.",
    ],
    appearance: APPEARANCE.HUMANOID
  },
  [OVERWHELMING]: {
    STR: 12,
    DEX: 14,
    CON: 15,
    WIL: 14,
    INT: 12,
    CHA: 0,
    attackSkill: 10,
    damage: "(3D10)",
    wounds: 2,
    awareness: 20,
    armor: 5,
    defense: 5,
    abilities: ["Aim", "Explosive"],
    roleProperties: [
      "The Arash skips its turn but adds +10 to its next attack skill.",
      "The Arash launches an explosive round that deals D20 damage.",
      "Can initiate attack 2 times/round",
    ],
    appearance: APPEARANCE.HUMANOID
  },
};
